//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    info: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      visible: false
    };
  },
  methods: {
    open: function open() {
      this.visible = true;
    }
  }
};